import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { EmployeeMultiselectDialog } from '../employee-popup/employee-popup.component';
import { process, State } from '@progress/kendo-data-query';
import { CityService } from '../../services/city.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService} from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import {
    EquipmentClass
    , Mode
    , OpportunityLanes
    , QuoteOrderType
    , SearchCityState
    , SearchModeEquipmentClassTrailerType
    , SearchOpportunityLanes
    , SearchQuoteOrderLineOpportunityCost
    , TrailerType
} from '../../models/models';

@Component({
    selector: 'customer-opportunity-lane-grid',
    templateUrl: './customer-opportunity-lane-grid.component.html',
    standalone: false
})
export class CustomerOpportunityLaneGrid implements OnInit, OnChanges {
    @Input() quoteOrderID: number = 0;
    @Input() opportunityID: number = 0;
    @Input() productID: number = 0;
    @Input() refreshDate: Date = new Date();
    @Output() onSelect = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public opportunityLanesGrid!: GridComponent;
    @ViewChild(GridComponent, { static: false }) public loadCostGrid!: GridComponent;
    @ViewChild(GridComponent, { static: false }) public uploadGrid!: GridComponent;
    @ViewChild('inputFile', { static: false }) public inputFile!: ElementRef;

    public dataSheet = new Subject();
    public baseUrl: string = this.utilService.getBaseUrl();

    // https://stackblitz.com/edit/angular-import-excel?file=app%2Fapp.component.ts
    private keys: string[] = [];
    public xlsData: string[] = [];
    public progressTotal: number = 0;
    private progressRunning: any;
    public searchOpportunityLanesList: SearchOpportunityLanes[] = [];
    public searchOpportunityLanesExportList: SearchOpportunityLanes[] = [];
    public searchOpportunityLane: SearchOpportunityLanes = {} as SearchOpportunityLanes;
    public opportunityLanesList: OpportunityLanes[] = [];
    public opportunityLane: OpportunityLanes = {} as OpportunityLanes;
    public loadCostList: SearchQuoteOrderLineOpportunityCost[] = [];
    private loadCostRowIndex: number = -1;
    public modeList: Mode[] = [];
    public equipmentClassList: EquipmentClass[] = [];
    public trailerTypeList: TrailerType[] = [];
    public modeEquipmentClassTrailerTypeList: SearchModeEquipmentClassTrailerType[] = [];
    public modeID: number = 0;
    public equipmentClassID: number = 0;
    public trailerTypeID: number = 0;
    private originCity: SearchCityState = {} as SearchCityState;
    private destinationCity: SearchCityState = {} as SearchCityState;
    public originCityID: number = 0;
    public destinationCityID: number = 0;
    public defaultOriginCity: string = "";
    public defaultDestinationCity: string = "";
    public isAddLane: boolean = false;
    public isEditLane: boolean = false;
    public isEditLaneError: boolean = false;
    public isUpload: boolean = false;
    public isExcelFile: boolean = false;
    public isSetOrderTypes: boolean = false;
    public isSelectAllLanes: boolean = false;
    private selectedLanes: number[] = [];
    public selectedOrderTypeID: number = 0;
    public orderTypeList: QuoteOrderType[] = [];
    public updateOrderTypeCounter: number = 0;
    public totalLineHaulCost: number = 0;
    public totalFuelCost: number = 0;

    public excelExportData(): ExcelExportData {
        const result: ExcelExportData = {
            data: process(this.searchOpportunityLanesExportList, {
                group: [],
                sort: []
            }).data,
            group: [],
        };
        return result;
    }

    public laneForm: UntypedFormGroup = new UntypedFormGroup({
        originCityCtrl: new UntypedFormControl(''),
        destinationCityCtrl: new UntypedFormControl('')
        //editOriginCityCtrl: new FormControl(''),
        //editDestinationCityCtrl: new FormControl('')
    });

    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'originCityST' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    public loadCostGridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'legNumber' }, { dir: 'asc', field: 'costTypeDescription' }] };
    public loadCostGridData: GridDataResult = { data: [], total: 0 };

    public uploadGridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'originCityName' }] };
    public uploadGridData: GridDataResult = { data: [], total: 0 };

    constructor(private cityService: CityService, private orderService: OrderService,
        public dialog: MatDialog, private notificationService: NotificationService,
        private ngZone: NgZone, private utilService: UtilService) {
        this.excelExportData = this.excelExportData.bind(this);
    }

    ngOnInit() {
        this.getSearchOpportunityLanesByOpportunityID();
        if (this.opportunityID > 0) {
            this.getOrderTypes();
            this.getSearchModeEquipmentClassTrailerTypes();
        }
    }

    ngOnChanges() {
        //console.log("ngOnChanges");
    }

    private getSearchModeEquipmentClassTrailerTypes() {
        this.orderService.getAllSearchModeEquipmentClassTrailerType().subscribe(result => {
            this.modeEquipmentClassTrailerTypeList = result.resultCollection;
            this.getModes();
            //this.setDefaults();
        });
    }

    private getModes() {
        //this.orderService.getModes().subscribe(result => {
        //    this.modeList = result;
        //});

        for (var i = 0; i < this.modeEquipmentClassTrailerTypeList.length; i++) {
            var idx = this.modeList.findIndex(t => t.modeID == this.modeEquipmentClassTrailerTypeList[i].modeID);
            if (idx < 0) {
                var mode: Mode = {
                    modeID: this.modeEquipmentClassTrailerTypeList[i].modeID,
                    abbrev: this.modeEquipmentClassTrailerTypeList[i].modeAbbrev,
                    description: this.modeEquipmentClassTrailerTypeList[i].modeDescription,
                    groupEmail: "",
                    defaultTrailerTypeId: 0,
                    includeInLogisticLaneInd: false,
                    sortOrder: this.modeEquipmentClassTrailerTypeList[i].modeSortOrder
                }
                this.modeList.push(mode);
                this.modeList = this.modeList.sort((left, right): number => {
                    if (left.sortOrder < right.sortOrder) return -1;
                    if (left.sortOrder > right.sortOrder) return 1;
                    return 0;
                });
            }
        }
    }

    private getEquipmentClasses() {
        //this.orderService.getEquipmentClasses().subscribe(result => {
        //    this.equipmentClassList = result.resultCollection;
        //});

        var subList = this.modeEquipmentClassTrailerTypeList.filter(t => t.modeID == this.modeID);
        for (var i = 0; i < subList.length; i++) {
            var idx = this.equipmentClassList.findIndex(t => t.equipmentClassID == subList[i].equipmentClassID);
            if (idx < 0) {
                var equipmentClass: EquipmentClass = {
                    equipmentClassID: subList[i].equipmentClassID,
                    abbreviation: subList[i].equipmentClassAbbrev,
                    className: subList[i].equipmentClassName,
                    sortOrder: subList[i].equipmentClassSortOrder
                }
                this.equipmentClassList.push(equipmentClass);
                this.equipmentClassList = this.equipmentClassList.sort((left, right): number => {
                    if (left.sortOrder < right.sortOrder) return -1;
                    if (left.sortOrder > right.sortOrder) return 1;
                    return 0;
                });
            }
        }
        //console.log("getEquipmentClasses", this.modeID, subList);
    }

    private getTrailerTypes() {
        //this.orderService.getTrailerTypes().subscribe(result => {
        //    this.trailerTypeList = result;
        //});

        var subList = this.modeEquipmentClassTrailerTypeList.filter(t => t.modeID == this.modeID && t.equipmentClassID == this.equipmentClassID && t.allowedOnLanes == true);
        for (var i = 0; i < subList.length; i++) {
            var idx = this.trailerTypeList.findIndex(t => t.trailerTypeID == subList[i].trailerTypeID);
            if (idx < 0) {
                var trailerType: TrailerType = {
                    trailerTypeID: subList[i].trailerTypeID,
                    abbrev: subList[i].trailerTypeAbbrev,
                    description: subList[i].trailerTypeDescription,
                    defaultModeID: subList[i].defaultModeID!,
                    allowedOnLanes: subList[i].allowedOnLanes!,
                    defaultLength: subList[i].defaultLength,
                    defaultWeight: subList[i].defaultWeight,
                    datEquipmentCode: "",
                    datEquipmentTypeId: 0,
                    erpCode: "",
                    includeInLogisticLaneInd: false,
                    sortOrder: subList[i].trailerTypeSortOrder
                }
                this.trailerTypeList.push(trailerType);
                this.trailerTypeList = this.trailerTypeList.sort((left, right): number => {
                    if (left.sortOrder < right.sortOrder) return -1;
                    if (left.sortOrder > right.sortOrder) return 1;
                    return 0;
                });
            }
        }
    }

    public modeChanged(evt: any) {
        var modeID = evt.target ? evt.target.value : evt;

        if (modeID > 0) {
            var mode = this.modeList.filter(t => t.modeID == modeID);
            if (mode != null && mode.length > 0) {
                this.opportunityLane.modeAbbreviation = mode[0].abbrev;
                var trailerType = this.trailerTypeList.filter(t => t.trailerTypeID == mode[0].defaultTrailerTypeId);

                if (trailerType != null && trailerType.length > 0) {
                    this.trailerTypeID = trailerType[0].trailerTypeID;
                    this.opportunityLane.trailerAbbreviation = trailerType[0].abbrev;
                }
            }
            else {
                this.trailerTypeID = 0;
                this.opportunityLane.modeAbbreviation = "";
            }
        } else {
            this.trailerTypeID = 0;
            this.opportunityLane.modeAbbreviation = "";
        }

        this.equipmentClassID = 0;
        this.trailerTypeID = 0;
        this.equipmentClassList.length = 0;
        this.trailerTypeList.length = 0;

        //console.log("modeChanged", evt, modeID, this.modeID, this.opportunityLane);

        this.getEquipmentClasses();
        this.getTrailerTypes();
    }

    public equipmentClassChanged(evt: any) {
        var classID = evt.target ? evt.target.value : evt;

        if (classID > 0) {
            var equipmentClass = this.equipmentClassList.filter(t => t.equipmentClassID == classID);
            if (equipmentClass != null && equipmentClass.length > 0) {
                //var trailerType = this.trailerTypeList.filter(t => t.trailerTypeID == equipmentClass[0].default);

                //    if (trailerType != null && trailerType.length > 0) {
                //        this.quoteOrderLine.trailerTypeID = trailerType[0].trailerTypeID;
                //        this.quoteOrderLine.trailerLength = trailerType[0].defaultLength;
                //    }
            }
            else {
                this.equipmentClassID = 0;
            }
        } else {
            this.equipmentClassID = 0;
        }

        this.trailerTypeID = 0;
        this.trailerTypeList.length = 0;

        //console.log("equipmentClassChanged", evt, classID, this.equipmentClassID, this.opportunityLane);

        this.getTrailerTypes();
    }

    public trailerTypeChanged(evt: any) {
        var trailerTypeID = evt.target ? evt.target.value : evt;

        if (trailerTypeID > 0) {
            var trailerType = this.trailerTypeList.filter(t => t.trailerTypeID == trailerTypeID);
            if (trailerType != null && trailerType.length > 0) {
                this.opportunityLane.trailerAbbreviation = trailerType[0].abbrev;
            }
            else {
                this.trailerTypeID = 0;
                this.opportunityLane.trailerAbbreviation = "";
            }
        } else {
            this.trailerTypeID = 0;
            this.opportunityLane.trailerAbbreviation = "";
        }
        //console.log("trailerTypeChanged", evt, trailerTypeID, this.opportunityLane);
    }

    private getOrderTypes() {
        this.orderService.getQuoteOrderTypesByProductID(this.productID).subscribe(result => {
            this.orderTypeList = result;
            this.orderTypeList = this.orderTypeList.filter(t => t.abbrev != "RW");
        });
    }

    private getSearchOpportunityLanesByOpportunityID() {
        this.utilService.isLoading = true;
        this.searchOpportunityLanesList.length = 0;
        this.orderService.getSearchOpportunityLanesByOpportunityID(this.opportunityID).subscribe(result => {
            this.utilService.isLoading = false;
            this.searchOpportunityLanesList = result.resultCollection;
            this.searchOpportunityLanesList = this.searchOpportunityLanesList.filter(t => t.quoteOrderTypeAbbrev != "CRFQ" && t.quoteOrderTypeAbbrev != "CQ");
            this.searchOpportunityLanesExportList = this.searchOpportunityLanesList.filter(t => t.numCost == t.numCostRequired && t.numCostRequired > 0 && t.baseLineHaulRate > 0);
            this.setGrid();
            //console.log("quoteOrderLineList:quoteOrderID", this.quoteOrderID, this.quoteOrderLineList.length);
        });
    }

    private getSearchQuoteOrderLineOpportunityCostByQuoteOrderID(quoteOrderID: number) {
        this.utilService.isLoading = true;
        this.loadCostList.length = 0;
        this.orderService.getSearchQuoteOrderLineOpportunityCostByQuoteOrderID(quoteOrderID).subscribe(result => {
            this.utilService.isLoading = false;
            this.loadCostList = result.resultCollection;
            this.setLoadCostGrid();
            //console.log("quoteOrderLineList:quoteOrderID", this.quoteOrderID, this.quoteOrderLineList.length);
        });
    }

    private setGrid() {
        this.gridData = process(this.searchOpportunityLanesList, this.gridState);
        this.fitColumns();
    }

    private setLoadCostGrid() {
        this.loadCostGridData = process(this.loadCostList, this.loadCostGridState);
        this.fitLoadCostColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.opportunityLanesGrid == null) return;
            this.opportunityLanesGrid.autoFitColumns();
        });
    }

    private fitLoadCostColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.loadCostGrid == null) return;
            this.loadCostGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.setGrid();
        //this.gridData = process(this.quoteOrderLineList, this.gridState);
    }

    public onGridDetailCollapse(evt: any) {
        if (this.loadCostRowIndex >= 0) {
            this.loadCostGrid.collapseRow(this.loadCostRowIndex);
        }
        this.loadCostRowIndex = -1;
        //console.log("onGridDetailCollapse", evt);
    }

    public onGridDetailExpand(evt: any) {
        if (this.loadCostRowIndex >= 0) {
            this.loadCostGrid.collapseRow(this.loadCostRowIndex);
        }
        this.loadCostRowIndex = evt.index;
        //this.loadCostList = [];
        this.getSearchQuoteOrderLineOpportunityCostByQuoteOrderID(evt.dataItem.quoteOrderID);
        //console.log("onGridDetailExpand", evt);
        //this.getTrackingBoardDetail(evt.dataItem);
    }

    public sendEmail(lane: SearchOpportunityLanes) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            data: {
                showNotes: true,
                showCheckCallNotes: false,
                showSystemNotes: false
            }
        }

        const dialogRef = this.dialog.open(EmployeeMultiselectDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            if (result == null ||
                ((result.selectedEmployees == null || result.selectedEmployees.length < 1) &&
                    (result.selectedGroupId == null || result.selectedGroupId < 1))) return;

            var emails = '';
            if (result.selectedEmployees != null) {
                result.selectedEmployees.forEach(e => {
                    emails += e.email + '|';
                });
            }

            if (result.selectedEmails != null) {
                emails += result.selectedEmails + '|';
            }

            this.orderService.sendQuoteOrderEmail(lane.quoteOrderID, "", emails, result.selectedGroupId, "", result.notes, 0, "", false, false, "", false).subscribe(emailResult => {
                var ok = emailResult;
            });
        });
    }

    public toggleWonChecked(quoteOrderID: number) {
        var idx: number = -1;
        if (quoteOrderID > 0) {
            idx = this.selectedLanes.findIndex(t => t == quoteOrderID);
            if (idx >= 0) {
                this.isSelectAllLanes = false;
                this.selectedLanes.splice(idx, 1);
            }
            else {
                this.selectedLanes.push(quoteOrderID);
            }
        }
        else {
            //this.isSelectAllLanes = true;
            this.isSelectAllLanes = !this.isSelectAllLanes;
            this.selectedLanes = [];
            if (this.isSelectAllLanes) {
                this.searchOpportunityLanesList.forEach(t => {
                    if (t.quoteOrderTypeAbbrev != "RW") {
                        this.selectedLanes.push(t.quoteOrderID);
                    }
                });
            }
        }
        //console.log("toggleWonChecked", idx, quoteOrderID, this.isSelectAllLanes, this.selectedLanes);
    }

    public isLaneSelected(quoteOrderID: number) {
        var isSelected: boolean = false;
        if (quoteOrderID > 0) {
            var idx = this.selectedLanes.findIndex(t => t == quoteOrderID);
            if (idx >= 0) {
                isSelected = true;
            }
        }
        //console.log("isLaneSelected", quoteOrderID, isSelected, this.isSelectAllLanes, this.selectedLanes);
        return isSelected;
    }

    public saveOrderTypes() {
        var employeeID: number = parseInt(localStorage.getItem('EmployeeId')!);
        this.utilService.isLoading = true;
        for (var i = 0; i < this.selectedLanes.length; i++) {
            this.orderService.setQuoteOrderType(this.selectedLanes[i], this.selectedOrderTypeID, employeeID).subscribe(result => {
                this.updateOrderTypeCounter++;
                //console.log("saveOrderTypes", result.resultCollection);
                if (this.updateOrderTypeCounter == this.selectedLanes.length) {
                    this.utilService.isLoading = false;
                    this.updateOrderTypeCounter = 0;
                    this.selectedOrderTypeID = 0;
                    this.selectedLanes = [];
                    this.isSetOrderTypes = false;
                    this.isSelectAllLanes = false;
                    this.getSearchOpportunityLanesByOpportunityID();
                    console.log("saveOrderTypes:end", this.updateOrderTypeCounter, this.selectedLanes);
                }
            });
        }
    }

    public citySTChanged(evt: any, cityType: string) {
        var cityID = evt;
        //console.log("citySTChanged", cityID, this.originCity, this.destinationCity);
        this.cityService.getSearchCityStateByCityID(cityID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                if (cityType == "origin") {
                    this.originCityID = cityID;
                    this.originCity = result.resultCollection[0];
                    this.opportunityLane.originCityID = cityID;
                    this.opportunityLane.originCityName = this.originCity.name.trim();
                    this.opportunityLane.originStateAbbreviation = this.originCity.stAbbr.trim();
                    this.opportunityLane.originZip = this.originCity.zip;
                    this.opportunityLane.originCountryCode = this.originCity.countryAbbr.trim();
                }
                else if (cityType == "destination") {
                    this.destinationCityID = cityID;
                    this.destinationCity = result.resultCollection[0];
                    this.opportunityLane.destinationCityID = cityID;
                    this.opportunityLane.destinationCityName = this.destinationCity.name.trim();
                    this.opportunityLane.destinationStateAbbreviation = this.destinationCity.stAbbr.trim();
                    this.opportunityLane.destinationZip = this.destinationCity.zip;
                    this.opportunityLane.destinationCountryCode = this.destinationCity.countryAbbr.trim();
                }
                //else if (cityType == "editOrigin") {
                //    this.originCityID = cityID;
                //    this.originCity = result.resultCollection[0];
                //    this.searchOpportunityLane.originCityID = cityID;
                //    this.searchOpportunityLane.originCityName = this.originCity.name.trim();
                //    this.searchOpportunityLane.originStateAbbreviation = this.originCity.stAbbr.trim();
                //    this.searchOpportunityLane.originZip = this.originCity.zip;
                //}
                //else if (cityType == "editDestination") {
                //    this.destinationCityID = cityID;
                //    this.destinationCity = result.resultCollection[0];
                //    this.searchOpportunityLane.destinationCityID = cityID;
                //    this.searchOpportunityLane.destinationCityName = this.destinationCity.name.trim();
                //    this.searchOpportunityLane.destinationStateAbbreviation = this.destinationCity.stAbbr.trim();
                //    this.searchOpportunityLane.destinationZip = this.destinationCity.zip;
                //}
                //console.log("citySTChanged:customerCity", cityID, this.originCity, this.destinationCity, result);
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    public calcRateMargin(isMarginChange: boolean) {
        // cost = Total Cost to Price
        //var costPrice: number = this.searchOpportunityLane.costToPriceTotal;
        //var costProtect: number = this.searchOpportunityLane.costToProtectTotal;
        // rate = Base Linehaul Rate
        //var rate: number = this.searchOpportunityLane.baseLineHaulRate;
        // margin = Cost to Price Margin
        //var baseMargin: number = this.searchOpportunityLane.baseLineHaulMargin;
        //var marginPrice: number = this.searchOpportunityLane.costToPriceMargin;
        //var protectMargin: number = this.searchOpportunityLane.costToProtectMargin;
        if (isMarginChange) {
            this.searchOpportunityLane.baseLineHaulRate = this.calcRate(this.searchOpportunityLane.costToPriceMargin, this.searchOpportunityLane.costToPriceTotal);
        }
        else {
            this.searchOpportunityLane.costToPriceMargin = this.calcMargin(this.searchOpportunityLane.costToPriceTotal, this.searchOpportunityLane.baseLineHaulRate, 0);
            this.searchOpportunityLane.baseLineHaulMargin = this.searchOpportunityLane.costToPriceMargin;
        }
        this.searchOpportunityLane.costToProtectMargin = this.calcMargin(this.searchOpportunityLane.costToProtectTotal, this.searchOpportunityLane.baseLineHaulRate, 0);
    }

    public calcFinalMargin(isCostToPrice: boolean) {
        var calc = 0;
        if (isCostToPrice) {
            calc = this.calcMargin(this.searchOpportunityLane.costToPriceTotal, this.searchOpportunityLane.baseLineHaulRate, this.searchOpportunityLane.customerFuelSurcharge);
        }
        else {
            calc = this.calcMargin(this.searchOpportunityLane.costToProtectTotal, this.searchOpportunityLane.baseLineHaulRate, this.searchOpportunityLane.customerFuelSurcharge);
        }
        return calc;
    }

    private calcRate(margin: number, cost: number) {
        var calc = 0;
        if (margin > 0) {
            if (margin > 1) {
                margin = margin / 100;
            }
            //calc = (rate + fsc) / (1 - margin);
            calc = cost / (1 - margin);
        }
        return parseFloat(calc.toFixed(2));
    }

    private calcMargin(cost: number, rate: number, fsc: number) {
        var calc = 0;
        if (rate > 0) {
            calc = 1 - cost / (rate + fsc);
        }
        calc = parseFloat(calc.toFixed(4));
        return calc;
    }

    public calcTotalNetPerOrder() {
        var calc = 0;
        //		ISNULL(ol.BaseLineHaulRate, 0) + ISNULL(ol.CustomerFuelSurcharge, 0) - (ISNULL(cprice.CostToPriceLineHaul, 0) + ISNULL(cprice.CostToPriceFuel, 0)) AS TotalNetPerOrder,
        calc = this.searchOpportunityLane.baseLineHaulRate + this.searchOpportunityLane.customerFuelSurcharge - (this.searchOpportunityLane.costToPriceLineHaul + this.searchOpportunityLane.costToPriceFuel);
        return calc;
    }

    public getCustomerFuelSurcharge(isFuelSurchargeChange: boolean) {
        var calc = 0;
        if (isFuelSurchargeChange) {
            if (this.searchOpportunityLane.miles > 0) {
                this.searchOpportunityLane.customerFuelSurchargePerMile = parseFloat((this.searchOpportunityLane.customerFuelSurcharge / this.searchOpportunityLane.miles).toFixed(2));
            }
        }
        else {
            this.searchOpportunityLane.customerFuelSurcharge = this.searchOpportunityLane.customerFuelSurchargePerMile * this.searchOpportunityLane.miles;
        }
        return calc;
    }

    public getTotalCustomerRate() {
        //return this.searchOpportunityLane.baseLineHaulRate + this.searchOpportunityLane.costToPriceFuel;
        return this.searchOpportunityLane.baseLineHaulRate + this.searchOpportunityLane.customerFuelSurcharge;
    }

    public editLane(lane: SearchOpportunityLanes) {
        this.searchOpportunityLane = Object.assign({}, lane);
        this.searchOpportunityLane.customerFuelSurchargePerMile = parseFloat((this.searchOpportunityLane.customerFuelSurchargePerMile).toFixed(2));
        //this.originCityID = this.searchOpportunityLane.originCityID;
        //this.defaultOriginCity = this.searchOpportunityLane.originCityName + ", " + this.searchOpportunityLane.originStateAbbreviation;
        //this.destinationCityID = this.searchOpportunityLane.destinationCityID;
        //this.defaultDestinationCity = this.searchOpportunityLane.destinationCityName + ", " + this.searchOpportunityLane.destinationStateAbbreviation;
        this.isEditLane = true;
        this.isEditLaneError = false;
        this.isAddLane = false;
        console.log("editLane", lane);
        //this.getModes();
        //this.getTrailerTypes();
        //this.utilService.isLoading = true;
        //this.orderService.getOpportunityLaneByID(lane.opportunityLanesID).subscribe(result => {
        //    this.utilService.isLoading = false;
        //    if (result.resultCollection.length > 0) {
        //        this.opportunityLane = result.resultCollection[0];
        //        this.isEditLane = true;
        //        this.defaultOriginCity = this.opportunityLane.originCityName + "," + this.opportunityLane.originStateAbbreviation;
        //        this.defaultDestinationCity = this.opportunityLane.destinationCityName + "," + this.opportunityLane.destinationStateAbbreviation;
        //    }
        //});
    }

    public editLaneError(lane: SearchOpportunityLanes) {
        this.isEditLane = false;
        this.isEditLaneError = true;
        this.isAddLane = false;
        this.defaultOriginCity = "";
        this.defaultDestinationCity = "";
        this.opportunityLane = {} as OpportunityLanes;
        this.opportunityLane.opportunityLanesID = lane.opportunityLanesID;
        this.opportunityLane.opportunityLaneBatchID = lane.opportunityLaneBatchID;
        this.opportunityLane.opportunityId = lane.opportunityID;
        this.opportunityLane.transactionDateTime = lane.transactionDateTime;
        this.opportunityLane.originCityID = lane.originCityID;
        this.opportunityLane.originCityName = lane.originCityName;
        this.opportunityLane.originStateAbbreviation = lane.originStateAbbreviation;
        this.opportunityLane.originCountryCode = lane.originCountryCode;
        this.opportunityLane.originZip = lane.originZip;
        this.opportunityLane.destinationCityID = lane.destinationCityID;
        this.opportunityLane.destinationCityName = lane.destinationCityName;
        this.opportunityLane.destinationStateAbbreviation = lane.destinationStateAbbreviation;
        this.opportunityLane.destinationCountryCode = lane.destinationCountryCode;
        this.opportunityLane.destinationZip = lane.destinationZip;
        this.opportunityLane.modeAbbreviation = lane.modeAbbreviation;
        this.opportunityLane.trailerAbbreviation = lane.trailerAbbreviation;
        this.opportunityLane.roundTrip = lane.roundTrip;
        this.opportunityLane.frequency = lane.frequency;
        this.opportunityLane.quoteOrderId = lane.quoteOrderID;
        this.opportunityLane.internalNotes = lane.internalNotes;
        this.opportunityLane.externalNotes = lane.externalNotes;
        this.opportunityLane.errorMessage = lane.errorMessage;
        this.opportunityLane.estimatedOrderCount = lane.estimatedOrderCount;
        this.opportunityLane.estimatedGross = lane.estimatedGross;
        this.opportunityLane.estimatedCost = lane.estimatedCost;
        this.opportunityLane.estimatedNet = lane.estimatedNet;
        this.opportunityLane.estimatedMargin = lane.estimatedMargin;
        this.opportunityLane.actualOrderCount = lane.actualOrderCount;
        this.opportunityLane.actualGross = lane.actualGross;
        this.opportunityLane.actualCost = lane.actualCost;
        this.opportunityLane.actualNet = lane.actualNet;
        this.opportunityLane.actualMargin = lane.actualMargin;
        this.opportunityLane.customerLaneID = lane.customerLaneID;
        this.opportunityLane.split1CustomerCode = lane.split1CustomerCode;
        this.opportunityLane.split2CustomerCode = lane.split2CustomerCode;

        //console.log("editLaneError", lane, this.opportunityLane);
    }

    public addSingleLane() {
        //this.getModes();
        //this.getTrailerTypes();
        this.isEditLane = false;
        this.isEditLaneError = false;
        this.isAddLane = true;
        this.defaultOriginCity = "";
        this.defaultDestinationCity = "";
        this.opportunityLane = {} as OpportunityLanes;
        this.opportunityLane.opportunityId = this.opportunityID;
        this.opportunityLane.internalNotes = "";
        this.opportunityLane.externalNotes = "";
        this.opportunityLane.customerLaneID = "";
        this.opportunityLane.split1CustomerCode = "";
        this.opportunityLane.split2CustomerCode = "";
    }

    //public saveLane() {
    //    this.isEditLane = false;
    //    this.saveUpload();
    //}

    public isValidAddLane() {
        var ret: boolean = false;
        if (this.opportunityLane.originCityID > 0
            && this.opportunityLane.destinationCityID > 0
            && this.opportunityLane.modeAbbreviation != null && this.opportunityLane.modeAbbreviation != ""
            && this.opportunityLane.trailerAbbreviation != null && this.opportunityLane.trailerAbbreviation != ""
            && this.modeID > 0
            && this.equipmentClassID > 0
            && this.trailerTypeID > 0
        ) {
            ret = true;
        }
        return ret;
    }

    public isValidEditLaneError() {
        var ret: boolean = false;
        if (this.opportunityLane.originCityID > 0
            && this.opportunityLane.destinationCityID > 0
        ) {
            ret = true;
        }
        return ret;
    }

    public saveAddLane() {
        this.opportunityLanesList = [];
        this.opportunityLanesList.push(this.opportunityLane);
        //this.saveUpload();
        this.utilService.isLoading = true;
        this.orderService.saveOpportunityLanes(this.opportunityLanesList).subscribe(result => {
            this.utilService.isLoading = false;
            this.cancelAddEdit();
            this.getSearchOpportunityLanesByOpportunityID();
        });
    }

    public saveEditLane() {
        this.utilService.isLoading = true;
        this.orderService.updateSearchOpportunityLanes(this.searchOpportunityLane).subscribe(result => {
            this.utilService.isLoading = false;
            this.cancelAddEdit();
            this.getSearchOpportunityLanesByOpportunityID();
        });
    }

    public saveEditLaneError() {
        this.utilService.isLoading = true;
        this.orderService.saveOpportunityLanesError(this.opportunityLane).subscribe(result => {
            this.utilService.isLoading = false;
            this.cancelAddEdit();
            this.getSearchOpportunityLanesByOpportunityID();
        });
    }

    public uploadFile(evt: any) {
        let data, header;
        const target: DataTransfer = <DataTransfer>(evt.target);
        this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
        if (target.files.length > 1) {
            this.inputFile.nativeElement.value = '';
        }
        if (this.isExcelFile) {
            this.utilService.isLoading = true;
            const reader: FileReader = new FileReader();
            reader.onload = (e: any) => {
                /* read workbook */
                const bstr: string = e.target.result;
                const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

                /* grab first sheet */
                const wsname: string = wb.SheetNames[0];
                const ws: XLSX.WorkSheet = wb.Sheets[wsname];

                /* save data */
                data = XLSX.utils.sheet_to_json(ws);
            };

            reader.readAsBinaryString(target.files[0]);

            reader.onloadend = (e) => {
                this.utilService.isLoading = false;
                this.keys = Object.keys(data[0]);
                this.dataSheet.next(data);
                for (var i = 0; i < data.length; i++) {
                    if (data[i].roundTrip.startsWith("Y") || data[i].roundTrip.startsWith("y") || data[i].roundTrip.startsWith("True") || data[i].roundTrip.startsWith("true")) {
                        data[i].roundTrip = true;
                    }
                    else {
                        data[i].roundTrip = false;
                    }
                }
                this.opportunityLanesList = Object.assign([], data);
                this.opportunityLanesList.forEach(t => {
                    t.opportunityLanesID = 0;
                    t.opportunityLaneBatchID = 0;
                    t.opportunityId = this.opportunityID;
                    t.quoteOrderId = 0;
                    if (!t.customerLaneID) {
                        t.customerLaneID = "";
                    }
                    if (!t.split1CustomerCode) {
                        t.split1CustomerCode = "";
                    }
                    if (!t.split2CustomerCode) {
                        t.split2CustomerCode = "";
                    }
                    t.originZip = t.originZip.toString();
                    t.destinationZip = t.destinationZip.toString();
                    t.errorMessage = "";
                    t.transactionDateTime = new Date();
                });
                this.setUploadGrid();
                //console.log(this.opportunityLanesList, data);
            }
        } else {
            this.inputFile.nativeElement.value = '';
        }
    }

    public saveUpload() {
        //this.utilService.isLoading = true;
        this.handleProgress();
        this.orderService.saveOpportunityLanes(this.opportunityLanesList).subscribe(result => {
            //this.utilService.isLoading = false;
            this.cancelUpload();
            this.getSearchOpportunityLanesByOpportunityID();
        });
    }

    private handleProgress() {
        var secondsPerRecord: number = 6;
        var numRecords: number = this.opportunityLanesList.length;
        var intervalTime: number = numRecords * secondsPerRecord * 1000 / 100;
        this.progressTotal = 1;
        this.progressRunning = setInterval(() => {
            if (this.progressTotal <= 100) {
                this.progressTotal++;
            } else {
                clearInterval(this.progressRunning);
            }
            //console.log("handleProgress", numRecords, intervalTime, this.progressTotal, this.progressRunning);
        }, intervalTime);
    }

    public cancelAddEdit() {
        this.opportunityLanesList = [];
        this.opportunityLane = {} as OpportunityLanes;
        this.originCity = {} as SearchCityState;
        this.destinationCity = {} as SearchCityState;
        this.originCityID = 0;
        this.destinationCityID = 0;
        this.defaultOriginCity = "";
        this.defaultDestinationCity = "";
        this.modeID = 0;
        this.equipmentClassID = 0;
        this.trailerTypeID = 0;
        this.toggleWonChecked(0);
        this.selectedOrderTypeID = 0;
        this.isSelectAllLanes = false;
        this.isSetOrderTypes = false;
        this.isAddLane = false;
        this.isEditLane = false;
        this.isEditLaneError = false;
        this.isUpload = false;
    }

    public cancelUpload() {
        this.inputFile.nativeElement.value = '';
        this.dataSheet.next(null);
        this.keys = [];
        this.progressTotal = 0;
        this.cancelAddEdit();
    }

    private setUploadGrid() {
        this.uploadGridData = process(this.opportunityLanesList, this.gridState);
        this.fitUploadColumns();
    }

    private fitUploadColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.uploadGrid == null) return;
            this.uploadGrid.autoFitColumns();
        });
    }
}
